let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dx9VT")).then(() => parcelRequire('57cTu'));